module.exports = __webpack_public_path__ + "static/media/atendimentohumano.f888b641.svg";